import { Render, type Data } from '@puckeditor/core'
import { renderToStaticMarkup } from 'react-dom/server'
import { exportConfig } from './config'
import { renderPopupHtml } from './renderHtml'

export const buildPopupHtml = (data: Data): string => {
    const content = renderToStaticMarkup(<Render config={exportConfig} data={data} />)
    const rootProps: Record<string, any> = (data.root as any)?.props ?? {}
    return renderPopupHtml({
        content,
        position: rootProps.position ?? 'center',
        animation: rootProps.animation ?? 'fade',
        overlay: rootProps.overlay ?? true,
        maxWidth: rootProps.maxWidth ?? 480,
        borderRadius: rootProps.borderRadius ?? 12,
    })
}
